// eslint-disable-next-line import/no-anonymous-default-export
export default {
  today: 'Bugün',
  title: 'Ödeme Takvimi',
  subtitle: 'Tüm ödemelerinizi takviminizde görün',
  exportToICS: 'ICS Olarak Dışa Aktar',
  downloadICS: 'ICS Olarak İndir',
  autoSyncEnabled: 'Otomatik Senkronizasyon Aktif',
  lastSync: 'Son',
  selectDate: 'Bir gün seçin',
  noEventsForDate: 'Bu tarih için ödeme yok',
  receivables: 'Alacaklar',
  payables: 'Verecekler',
  frequency: 'Sıklık',
  monthly: 'Aylık',
  yearly: 'Yıllık',
  oneTime: 'Tek Seferlik',
  receivable: 'Alacak',
  payable: 'Verecek',
  amount: 'Tutar',
  company: 'Şirket',
  domain: 'Domain',
  provider: 'Sağlayıcı',
  notes: 'Notlar',
  description: 'Açıklama',
  recurringPayment: 'Tekrarlı Ödeme',
  serverPayment: 'Sunucu Ödemesi',
  payment: 'Ödeme',
  fetchError: 'Takvim verileri alınamadı',
  calendarUpdated: 'Takvim güncellendi',
  syncError: 'Senkronizasyon hatası',
  webcalUrlCopied: 'Webcal URL kopyalandı',
  urlCopyError: 'URL kopyalanamadı',
  noEventsToExport: 'Export edilecek etkinlik bulunamadı',
  icsCreateError: 'ICS dosyası oluşturulamadı',
  exportSuccess: 'Takvim başarıyla export edildi!',
  webcalUrlTitle: 'Webcal URL',
  copyUrl: 'URL\'i kopyala',
  openWebcalUrl: 'Webcal URL\'i aç',
  webcal: 'Webcal',
  email: 'Email',
  phone: 'Telefon',
  status: 'Durum',
  statusReceived: 'Tahsil Edildi',
  statusPending: 'Beklemede',
  statusOverdue: 'Gecikmiş',
  received: 'Tahsil',
  invoice: 'Fatura',
  addToGoogle: 'Google\'a Ekle',
  january: 'Ocak',
  february: 'Şubat',
  march: 'Mart',
  april: 'Nisan',
  may: 'Mayıs',
  june: 'Haziran',
  july: 'Temmuz',
  august: 'Ağustos',
  september: 'Eylül',
  october: 'Ekim',
  november: 'Kasım',
  december: 'Aralık',
  sun: 'Paz',
  mon: 'Pzt',
  tue: 'Sal',
  wed: 'Çar',
  thu: 'Per',
  fri: 'Cum',
  sat: 'Cmt'
};
